export enum enumBookingStatus {
    PAYMENT_PROCESSING = 1,
    ADVANCE_PAYED = 2,
    PAYED = 3,
    SUSPENDED = 4,
    CANCELED = 5,
    REFUNDED = 6,
    PENDING_REFUND = 7,
}